import LocalStore from './local_store'
import { isAfter, sub } from 'date-fns'
import Welcome from '../messages/welcome.hamlc'
import WelcomeNewUser from '../messages/welcome_new_user.hamlc'
import Moderation from '../messages/moderation.hamlc'
import _ from 'underscore'

function hasViewed (type, id) {
  const views = this.get(type)

  return _.any(views, (view) => {
    return view.id === id
  })
}

function trackView (type, id) {
  const views = this.get(type)

  views.push({
    id: id,
    tracked_at: new Date().toUTCString()
  })

  this.save()
}

export class UserMessages extends Backbone.Model {
  get idAttribute () { return 'user_id' }
  get defaults () {
    return {
      last_updated: new Date().toUTCString(),
      // different types of messages
      intros: [],
      upsells: [],
      updates: []
    }
  }

  get rules () {
    return {
      // Introductory content for certain features or areas
      intros: {
        welcome: {
          content: () => {
            const userCreatedAt = new Date(this.get('user_created_at'))
            const oneDayAgo = sub(new Date(), { days: 1 })
            const isNewUser = isAfter(userCreatedAt, oneDayAgo)

            if (isNewUser) {
              return WelcomeNewUser
            } else {
              return Welcome
            }
          },
          shouldView: () => {
            return !this.hasViewed('intros', 'welcome')
          }
        }
      },
      // Upsell content for paid features
      upsells: {
        moderation: {
          content: () => Moderation,
          shouldView: () => {
            return !this.hasViewed('upsells', 'moderation')
          }
        }
      }
    }
  }

  getIntroContent (id) {
    if (this.shouldIntro(id)) {
      return this.rules.intros[id].content.call(this)
    } else {
      return null
    }
  }

  getUpsellContent (id, force = false) {
    if (force || this.shouldUpsell(id)) {
      return this.rules.upsells[id].content.call(this)
    } else {
      return null
    }
  }

  getUpdates (length = 1) {
    // TODO
  }

  // Should this view be showed
  shouldIntro (id) {
    return !hasViewed.call(this, 'intros', id)
  }

  shouldUpsell (id) {
    return !hasViewed.call(this, 'upsells', id)
  }

  trackIntro (id) {
    if (_.has(this.rules.intros, id)) {
      trackView.call(this, 'intros', id)
    }
  }

  trackUpsell (id) {
    if (_.has(this.rules.upsells, id)) {
      trackView.call(this, 'upsells', id)
    }
  }

  trackUpdate (id) {
    trackView.call(this, 'updates', id)
  }

  clear () {
    // clear intros and upsells only.
    // you don't want to see super old update messages
    this.set({
      intros: [],
      upsells: []
    })

    this.save()
  }

  save () {
    // no op
    this.set({ last_updated: new Date().toUTCString() })
    this.trigger('save', {})
  }
}

export default class Messages extends LocalStore {
  get model () { return UserMessages }
  get key () { return 'singularity_message_history' }
}
